export default defineAppConfig({
  site: {
    orgName: 'Школа Библии',
    logoLines: { line1: 'ШКОЛА', line2: 'БИБЛИИ' },
    defaultCountryIso: 'by',
    geoDetect: false,
    showRegionField: false,
    showExpertsSection: false,
    phone: '+375 33 677 16 77',
    phoneTel: '+375336771677',
    email: null as string | null,
    supportUrl: null as string | null,
  },
})
